import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const PlayFilledIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.2854 11.5713L6.75725 6.45435C6.42399 6.25439 6 6.49445 6 6.88309V17.1169C6 17.5056 6.42399 17.7456 6.75725 17.5457L15.2854 12.4287C15.6091 12.2345 15.6091 11.7655 15.2854 11.5713Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { PlayFilledIcon };
